import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class DetailedPayrollExporter  {
    _originalTypeClassName = "zERP.BO.DetailedPayrollExporter";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
DetailedPayrollExporter.translate = translateService;
}
this.DetailedPayrollExporterKey = null;
this._key = this.DetailedPayrollExporterKey = 0; 
}

static translate: TranslateService;
_key: any;
private _DetailedPayrollExporterKey:any;
get DetailedPayrollExporterKey(): any {
    return this._DetailedPayrollExporterKey;
  }
set DetailedPayrollExporterKey(value: any) {
    this._DetailedPayrollExporterKey = value;
    this._key = value;
  }

static ExecuteGetBasicSalaryValue(data: any,codes: any): any{let details = [];
if (codes?.linq?.where()?.firstOrDefault(null) == "0" || CLMS.Framework.String.IsNullOrEmpty(codes?.linq?.where()?.firstOrDefault(null)) || CLMS.Framework.String.IsNullOrEmpty((codes?.linq?.where()?.firstOrDefault(null) ?? '').trim())) {details = data?.Salaries?.linq?.where((s) => s?.Salary?.RuleType == Domain.SalaryRuleType.Basic && CLMS.Framework.Number.Equal(() => s.Salary.Priority, () => 0))?.toArray();}else {details = data?.Salaries?.linq?.where((s) => s?.Salary?.RuleType == Domain.SalaryRuleType.Basic && codes?.linq?.contains(s?.Salary?.Code))?.toArray();}
return ((CLMS.Framework.Number.Equal(() => details.length, () => 0) || details == null) ? 0 : details?.linq?.sum((d) => d?.Amount));
}
static ExecuteGetEmpContributionValue(data: any,codes: any): any{let details = data?.Contributions?.linq?.where((s) => codes?.linq?.contains(s?.Rule?.Code))?.toArray();
return (details == null ? 0 : details?.linq?.sum((l) => l?.EmployeeContribution));
}
static ExecuteGetEmpDeductionValue(data: any,codes: any): any{let deduction = data?.Deductions?.linq?.where((s) => codes?.linq?.contains(s?.Rule?.Code))?.toArray();
return (deduction == null ? 0 : deduction?.linq?.sum((d) => d?.EmployeeAmount));
}
static ExecuteGetEmployerContributionValue(data: any,codes: any): any{let details = data?.Contributions?.linq?.where((s) => codes?.linq?.contains(s?.Rule?.Code))?.toArray();
return (details == null ? 0 : details?.linq?.sum((l) => l?.EmployerContribution));
}
static ExecuteGetMainSalaryValue(data: any,codes: any): any{let details = data?.Salaries?.linq?.where((s) => s?.Salary?.RuleType == Domain.SalaryRuleType.Main && codes?.linq?.contains(s?.Salary?.Code))?.toArray();
return (details == null ? 0 : details?.linq?.sum((s) => s?.Amount));
}
static ExecuteGetOtherSalaryValue(data: any,codes: any): any{let details = data?.Salaries?.linq?.where((s) => s?.Salary?.RuleType == Domain.SalaryRuleType.Other && codes?.linq?.contains(s?.Salary?.Code))?.toArray();
return (details == null ? 0 : details?.linq?.sum((d) => d?.Amount));
}
static GetCollectionVariables(calculation: any): any{let vars = new window['Map']();
let employeesChildren = [];
employeesChildren?.add({
Name: "BLOCK_HEADER",Description: "Τίτλος Μπλοκ Εργαζομένου",}
);
employeesChildren?.add({
Name: "WORK_DAYS_BLOCK",Description: "Χρονικά Στοιχεία",}
);
employeesChildren?.add({
Name: "BASIC_SALARY_BLOCK",Description: "Βασικές Αποδοχές",}
);
employeesChildren?.add({
Name: "MAIN_SALARY_BLOCK",Description: "Κύριες Αποδοχές",}
);
employeesChildren?.add({
Name: "OTHER_SALARY_BLOCK",Description: "Λοιπές Αποδοχές",}
);
employeesChildren?.add({
Name: "EMP_CONTRIBUTIONS_BLOCK",Description: "Ασφαλιστικές εισφορές εργαζομένου",}
);
employeesChildren?.add({
Name: "DEDUCTIONS_BLOCK",Description: "Κρατήσεις εργαζομένου",}
);
employeesChildren?.add({
Name: "NET_PAY_BLOCK",Description: "Πληρωτέο",}
);
employeesChildren?.add({
Name: "ER_CONTRIBUTIONS_BLOCK",Description: "Ασφαλιστικές εισφορές εργοδότη",}
);
employeesChildren?.add({
Name: "TOTAL_COST_BLOCK",Description: "Σύνολο κόστους",}
);
employeesChildren?.add({
Name: "SUM_BASIC_SALARY",Description: "Σύνολο Βασικών Αποδοχών",}
);
employeesChildren?.add({
Name: "SUM_MAIN_SALARY",Description: "Σύνολο Κύριων Αποδοχών",}
);
employeesChildren?.add({
Name: "SUM_EMP_CONTRIBUTIONS",Description: "Σύνολο Ασφαλιστικών Εισφορών Εργαζομένου",}
);
employeesChildren?.add({
Name: "SUM_DEDUCTIONS",Description: "Σύνολο κρατήσεων",}
);
employeesChildren?.add({
Name: "SUM_NET_PAY",Description: "Σύνολο Πληρωτέου",}
);
employeesChildren?.add({
Name: "SUM_ER_CONTRIBUTIONS",Description: "Σύνολο Ασφαλιστικών Εισφορών Εργοδότη",}
);
employeesChildren?.add({
Name: "SUM_TOTAL_COST",Description: "Σύνολο κόστους (Σύνολο)",}
);
vars.set({
Name: "EMPLOYEES",Description: "Detailed Employees",IsCollection: true,Children: employeesChildren,}
, Joove.Common.cast(calculation?.Employees, "System.Collections.List"));
return vars;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.DetailedPayrollExporterKey == null || $this.DetailedPayrollExporterKey == 0;
            }


}